export default {"src":"/_next/static/media/tips_green.94caf78e.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};